<template>
  <div class="container home">
    <img class="img-home" alt="iPad Quality Guard" src="~@/assets/images/home.png">
    <div class="content">
      <div class="header">
        <img class="img-logo" alt="Logo Quality Guard" src="~@/assets/images/logo-default.png">
      </div>
      <h1><strong>Win een iPad!</strong></h1>
      <p>Neem deel aan onze Quality Guard Wedstrijd en maak kans om een gloednieuwe iPad te winnen!</p>
      <ck-button class="btn-home" action="Neem deel!" @click.native="$router.push({ name: 'step-1' })" />
    </div>
  </div>
</template>

<script>
export default {};
</script>
